import React, { useContext } from 'react';

let authContext = React.createContext(undefined);
let permissionsContext = React.createContext(undefined);
let menuContext = React.createContext(undefined);

const ensureContext = (value, name) => {
  if (value === undefined) {
    throw new Error(`${name} is not registered. Call registerAccessContexts or a dedicated register function before using related components.`);
  }

  return value;
};

export const registerAuthContext = context => {
  authContext = context;
};

export const registerPermissionsContext = context => {
  permissionsContext = context;
};

export const registerMenuContext = context => {
  menuContext = context;
};

export const registerAccessContexts = ({ auth, permissions, menu } = {}) => {
  if (auth) {
    registerAuthContext(auth);
  }

  if (permissions) {
    registerPermissionsContext(permissions);
  }

  if (menu) {
    registerMenuContext(menu);
  }
};

export const useAuth = () => {
  const contextValue = useContext(authContext);
  return ensureContext(contextValue, 'Auth context');
};

export const usePermissions = () => {
  const contextValue = useContext(permissionsContext);
  return ensureContext(contextValue, 'Permissions context');
};

export const useMenu = () => {
  const contextValue = useContext(menuContext);
  return ensureContext(contextValue, 'Menu context');
};

export const getAuthContext = () => authContext;
export const getPermissionsContext = () => permissionsContext;
export const getMenuContext = () => menuContext;
